export function _(selector, element = document) {
    return element.querySelector(selector);
}

export function __(selector, element = document) {
    return element.querySelectorAll(selector);
}

export function _id(elementId) {
    return document.getElementById(elementId);
}

export function findParent(ele, condition, maxLookup = 10) {
    let element = ele;
    for(
        let safe = 0;
        safe < maxLookup && element && !condition(element);
        safe++)
    {
        element = element.parentNode;
    }
    return element;
}

export function findChild(ele, condition, maxLookup = 10) {
    return findChildren(ele, condition, maxLookup, 1)[0];
}

export function findChildren(ele, condition, maxLookup = 10, limit = Infinity) {
    let output = [];
    let children = ele.childNodes;

    for(let safe = 0; safe < maxLookup && output.length < limit && children.length; safe++) {
        let nextChildTier = [];

        children.forEach(child => {
            if(condition(child)) {
                output.push(child);
            }
            nextChildTier = nextChildTier.concat(Array.prototype.slice.call(child.childNodes));
        });

        children = nextChildTier;
    }

    return output;
}